import { render, staticRenderFns } from "./TqWysiwygEditor.vue?vue&type=template&id=6071ee23&scoped=true&"
import script from "./TqWysiwygEditor.vue?vue&type=script&lang=js&"
export * from "./TqWysiwygEditor.vue?vue&type=script&lang=js&"
import style0 from "./TqWysiwygEditor.vue?vue&type=style&index=0&id=6071ee23&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6071ee23",
  null
  
)

export default component.exports